import {NgModule} from "@angular/core";
import {ProductThumbCarouselComponent} from "./product-thumb-carousel.component";
import {SharedModule} from "../../../shared.module";

@NgModule({
    imports: [SharedModule],
    declarations: [ProductThumbCarouselComponent],
    exports: [ProductThumbCarouselComponent]
})
export class ProductThumbCarouselModule { }
